import { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';
import ServiceSubNav from '@/components/base/ServiceSubNav';

const SERVICE_SUBNAV_ITEMS = [
  { label: '熱銷配方', path: '/services/hot-formulas' },
  { label: '天然原料', path: '/services/natural-ingredients' },
  { label: '各類劑型', path: '/services/dosage-forms' },
  { label: '包裝設計', path: '/services/packaging' },
];

const categories = [
  {
    id: 'animal',
    icon: 'ri-anchor-line',
    title: '動物來源',
    color: '#ef9a9a',
    bgColor: '#fff5f5',
    intro: '來自海洋與陸地動物的高生物利用率原料，富含人體必需的胺基酸、蛋白質與活性成分，吸收效率佳。',
    highlights: ['高生物利用率', '富含必需胺基酸', '天然活性成分'],
    ingredients: [
      { name: '膠原蛋白', desc: '從豬、牛、魚萃取，分子量小、吸收快，是各種美肌、關節健康的核心原料。' },
      { name: '魚油', desc: '富含 EPA、DHA， rTG 型更好吸收，支持心血管、全方位身體健康。' },
      { name: '乳清蛋白', desc: '分離、濃縮等多樣性蛋白，不同營養支援不同健康需求。' },
      { name: '初乳胜肽', desc: '富含免疫球蛋白與生長因子，支持嬰幼兒成長與成人穩固免疫力。' },
      { name: '其他原料', desc: '鮭魚軟骨、鮭魚精巢、乳脂球膜、牛乳萃取、乳鐵蛋白、酪蛋白水解物、牛奶鈣、牛乳蛋白、胜肽、豬軟骨、卵磷脂、水解蛋黃粉、酪蛋白磷酸胜肽、燕窩萃取、雞冠萃取物、螯合鈣、甲殼素、珍珠粉', spanFull: true },
    ],
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/9c67d9da8a13fb7d346809a479e83973.jpeg',
  },
  {
    id: 'plant',
    icon: 'ri-plant-line',
    title: '植物來源',
    color: '#4CAF50',
    bgColor: '#f0faf0',
    intro: '涵蓋根莖葉果萃取，來自全球各地的天然植物原料，提供多元的功效支持，符合現代消費者對天然成分的偏好。',
    highlights: ['天然植萃', '多樣功效', '消費者偏好'],
    ingredients: [
      { name: '植物性蛋白', desc: '多樣性植物蛋白（大豆、豌豆、米），給素食者群友善的高品質營養。' },
      { name: '膳食纖維', desc: '專業膳食纖維有效幫助腸道消化順暢，更是優質益生元。' },
      { name: '金盞花萃取葉黃素', desc: '可申請原廠授權之原料，高品質、高營養有認證保障。' },
      { name: '金盞花萃取葉黃素', desc: '可申請原廠授權之原料，高品質、高營養有認證保障。' },
      { name: '其他原料', desc: '穀光甘肽、洛神花萃取、小米草萃取、洋甘菊萃取、亞麻仁籽粉、菊苣纖維、洋車前子、芝麻萃取、香蜂草萃取、紅景天萃取、紅麴萃取、玄米萃取（神經醯胺）、透納葉萃取、鈉豆萃取、玄米發酵物、綠茶萃取物、武靴葉萃取、大豆卵磷脂、藤黃果萃取、胡椒鹼、南瓜籽萃取、薑黃萃取、玉米來源水溶性膳食纖維、決明子萃取、玉米黃素、黑豆皮萃取、白腎豆萃取、綠咖啡豆萃取、山苦瓜萃取、紅葡萄萃取（白藜蘆醇）、冰晶番茄、蔓越莓萃取、山桑子萃取、非洲芒果萃取、香瓜萃取（SOD 超氧化物歧化酶）、南非醉茄萃取、黑醋栗萃取', spanFull: true },
    ],
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/c0c70c228be323733d5bbb33493efd2f.jpeg',
  },
  {
    id: 'mushroom',
    icon: 'ri-seedling-line',
    title: '菇蕈來源',
    color: '#8d6e63',
    bgColor: '#faf5f0',
    intro: '功能性菇蕈類含有多醣體、三萜類等獨特活性成分，在東方傳統保健中使用已久，現代科學研究也持續驗證其功效。',
    highlights: ['多醣體豐富', '東方傳統智慧', '多重功效'],
    ingredients: [
      { name: '酵素複方', desc: '結合蔬果發酵萃取之酵素，可有助消化、提升體內代謝力。' },
      { name: '靈芝萃取', desc: '富含多醣體，對於免疫調節、抗氧化為頂級的菇蕈原料。' },
      { name: '酵母來源', desc: '透過酵母發酵之營養素，提供天然零化工的營養，吸收無負擔。' },
      { name: '黑木耳', desc: '天然菇蕈來源之一，低熱量、高飽足感，且可促進腸道蠕動，全方位健康維持。' },
      { name: '其他原料', desc: '酵母來源礦物質、綜合消化酵素、麩胺酸發酵物(GABA)、啤酒酵母、靈芝多醣、綜合蔬果發酵、蛋白質分解酵素、解脂酵素、後生元、乳酸菌、澱粉分解酵素、NMN、益生菌、抗敏益生菌、芽孢乳酸菌、鼠李醣乳桿菌、乳雙歧桿菌、凝結芽孢桿菌、唾液乳桿菌、副乾酪乳桿菌、私密處益生菌', spanFull: true },
    ],
    img: 'https://readdy.ai/api/search-image?query=functional%20mushroom%20supplement%20reishi%20ganoderma%20lion%20mane%20extract%20natural%20health%20product%20on%20dark%20wood%20background%2C%20traditional%20Chinese%20medicine%20herbs%20wellness%20photography&width=600&height=380&seq=ni-mushroom-01&orientation=landscape',
  },
  {
    id: 'algae',
    icon: 'ri-water-flash-line',
    title: '藻類油脂',
    color: '#26a69a',
    bgColor: '#f0fafa',
    intro: '海洋藻類是天然 DHA、EPA 與多種微量元素的優質來源，適合素食者使用，也是永續環境友善的原料選擇。',
    highlights: ['素食友善', '海洋永續', '高純度 DHA'],
    ingredients: [
      { name: '海藻鈣', desc: '富含多醣體，對於免疫調節、抗氧化為頂級的菇蕈原料。' },
      { name: '紅藻萃取', desc: '透過酵母發酵之營養素，提供天然零化工的營養，吸收無負擔。' },
      { name: '其他原料', desc: 'DHA藻油、微藻 DHA、小球藻萃取、杜莎藻萃取(胡蘿蔔素)、海藻萃取物(洗膅素)', spanFull: true },
    ],
    img: 'https://readdy.ai/api/search-image?query=algae%20oil%20DHA%20spirulina%20chlorella%20astaxanthin%20marine%20plant%20based%20supplement%20ingredient%20on%20teal%20blue%20green%20background%2C%20sustainable%20ocean%20health%20product%20photography&width=600&height=380&seq=ni-algae-01&orientation=landscape',
  },
  {
    id: 'biochem',
    icon: 'ri-flask-line',
    title: '生化類群',
    color: '#5c6bc0',
    bgColor: '#f5f5ff',
    intro: '透過生化技術製程生產的高純度活性物質，功效明確、含量穩定，是功能性保健品配方不可或缺的核心成分。',
    highlights: ['高純度', '含量穩定', '功效明確'],
    ingredients: [
      { name: '流行鏈球菌發酵物', desc: '含透明質酸鈉，純度高，為素食來源，且能有效保水維持肌膚等健康。' },
      { name: 'L-精胺酸', desc: '人體必需胺基酸之一，能促進體內血液循環，有助心血管保健及男性健康維持。' },
      { name: '支鏈胺基酸(BCAA)', desc: '結合高蛋白，可促進蛋白質合成，有助減少運動疲勞，加速肌肉修復。' },
      { name: '維生素', desc: '參與體內多項化學變化，有助調節生理機能，穩定基礎機能運作。' },
      { name: '其他原料', desc: '甘胺酸鎂、磷脂醯絲胺酸、綜合胺基酸、葡萄糖、Q10、β 葡聚醣、精胺酸、牛磺酸、D 甘露糖、甘胺酸鋅、礦物質、左旋肉鹼、肌酸、色胺酸、檸檬酸鈣、氧化鎂、HMB、K2、肉鹼', spanFull: true },
    ],
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/1e9874892b21e1e2ea7a6a44b7eb704c.jpeg',
  },
];

export default function NaturalIngredientsContent() {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <>
      {/* Hero */}
      <section className="relative pt-20 min-h-[360px] md:min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20natural%20raw%20ingredients%20herbs%20botanical%20extracts%20fish%20oil%20mushrooms%20algae%20vitamins%20arranged%20on%20clean%20white%20marble%20surface%2C%20health%20supplement%20raw%20material%20sourcing%20professional%20photography&width=1920&height=420&seq=ni-hero-bg-01&orientation=landscape"
            alt="天然原料背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <Breadcrumb
              items={[
                { label: '首頁', href: '/' },
                { label: '代工服務', href: '/services' },
                { label: '天然原料' },
              ]}
              className="mb-4 text-gray-300"
            />
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              代工服務
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              天然原料
            </h1>
            <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              從動物、植物、菇蕈、藻類油脂到生化營養來源，依產品定位挑選合適原料方向。
            </p>
          </div>
        </div>
      </section>

      {/* Category overview */}
      <section className="py-6 bg-white border-b border-gray-100">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setActiveId(null)}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-[0.875rem] font-medium transition-all duration-200 cursor-pointer ${
                activeId === null ? 'bg-[#4CAF50] text-white' : 'bg-[#f7faf7] text-gray-600 border border-gray-200 hover:border-green-300 hover:text-[#4CAF50]'
              }`}
            >
              全部類別
            </button>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveId(cat.id === activeId ? null : cat.id)}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-[0.875rem] font-medium transition-all duration-200 cursor-pointer ${
                  activeId === cat.id ? 'bg-[#4CAF50] text-white' : 'bg-[#f7faf7] text-gray-600 border border-gray-200 hover:border-green-300 hover:text-[#4CAF50]'
                }`}
              >
                {cat.title}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 space-y-8">
          {categories
            .filter((c) => activeId === null || c.id === activeId)
            .map((cat) => (
              <div key={cat.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
                {/* Category header */}
                <div className="flex flex-col lg:flex-row">
                  <div className="w-full lg:w-[360px] flex-shrink-0">
                    <img
                      src={cat.img}
                      alt={cat.title}
                      className="w-full h-[260px] lg:h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 p-7">
                    <div className="flex items-center gap-3 mb-3">
                      <div
                        className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                        style={{ backgroundColor: `${cat.color}20` }}
                      >
                        <i className={`${cat.icon} text-xl`} style={{ color: cat.color }} />
                      </div>
                      <h2 className="text-[#1a2e1a] font-bold text-[1.375rem]">{cat.title}</h2>
                    </div>
                    <p className="text-gray-600 text-[1rem] leading-[1.75] mb-4">{cat.intro}</p>
                    <div className="flex flex-wrap gap-2 mb-5">
                      {cat.highlights.map((h) => (
                        <span
                          key={h}
                          className="text-[0.8125rem] font-medium px-3 py-1 rounded-full border"
                          style={{ color: cat.color, borderColor: `${cat.color}40`, backgroundColor: `${cat.color}10` }}
                        >
                          {h}
                        </span>
                      ))}
                    </div>

                    {/* Ingredient list */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {cat.ingredients.map((ing) => {
                        const isSpanFull = (ing as any).spanFull;
                        return (
                        <div key={ing.name} className={`flex items-start gap-3 bg-[#f7faf7] rounded-xl p-3.5 ${isSpanFull ? 'sm:col-span-2' : ''}`}>
                          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <i className="ri-checkbox-circle-fill text-[#4CAF50] text-base" />
                          </div>
                          <div className="min-w-0">
                            <p className="text-[#1a2e1a] font-semibold text-[0.875rem] mb-0.5">{ing.name}</p>
                            <p className={`text-gray-500 text-[0.8125rem] leading-[1.65] ${isSpanFull ? 'max-w-full' : ''}`}>{ing.desc}</p>
                          </div>
                        </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Quality assurance */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-10">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
              原料把關
            </span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] mb-3">每批原料，嚴格驗收</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto">
              康永生技對所有原料實施嚴格的進廠驗收制度
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {[
              { icon: 'ri-test-tube-line', title: '農藥殘留檢驗', desc: '每批原料進行農藥殘留多項目篩檢' },
              { icon: 'ri-drop-line', title: '重金屬分析', desc: '鉛、汞、砷、鎘等重金屬全面檢測' },
              { icon: 'ri-bug-line', title: '微生物檢驗', desc: '菌落總數、大腸桿菌等微生物安全確認' },
              { icon: 'ri-file-check-line', title: '成分含量驗證', desc: '確認有效成分含量符合規格書標準' },
            ].map((item) => (
              <div key={item.title} className="bg-[#f7faf7] rounded-2xl p-5 text-center border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl mx-auto mb-3 border border-green-100">
                  <i className={`${item.icon} text-[#4CAF50] text-xl`} />
                </div>
                <h3 className="text-[#1a2e1a] font-bold text-[0.9375rem] mb-1.5">{item.title}</h3>
                <p className="text-gray-500 text-[0.8125rem] leading-[1.65]">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] leading-tight mb-4">
            想了解特定原料的合規性與報價？
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto mb-8">
            康永生技可協助您評估原料可行性，並提供符合台灣法規的原料選用建議。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              洽詢原料規劃
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services/hot-formulas"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              瀏覽熱銷配方
            </Link>
          </div>
        </div>
      </section>
      <ServiceSubNav
        items={SERVICE_SUBNAV_ITEMS}
        backLabel="返回服務總覽"
        backPath="/services"
        sectionLabel="其他服務頁面"
      />
      <RelatedPages items={[
        { title: '熱銷配方', desc: '了解 17 大市場熱銷配方方向，找到最適合您品牌的切入點。', href: '/services/hot-formulas' },
        { title: '各類劑型', desc: '膠囊、錠劑、粉劑、果凍條…選擇最能體現原料特性的劑型。', href: '/services/dosage-forms' },
        { title: '洽詢 ODM 合作', desc: '填寫諮詢表單，讓康永協助您規劃最適合的原料組合。', href: '/contact/form' },
      ]} />
    </>
  );
}
